<template>
    <div class="historial-container position-relative">
      <!-- Contador flotante en esquina superior derecha -->
      <div class="position-absolute top-0 end-0 mt-3 me-4">
        <div class="inventory-summary text-end">
          <h1 class="inventory-count">{{ historialFiltrado.length }}</h1>
          <p class="inventory-title">Rentas</p>
        </div>
      </div>
  
      <!-- Título -->
      <h2 class="text-center mb-3">Historial de Rentas</h2>
  
      <!-- Filtros por fecha -->
      <div class="filtros-fecha d-flex justify-content-center gap-3 mb-3 flex-wrap align-items-center">
        <input
          type="date"
          v-model="filtroDesde"
          class="form-control"
          :max="fechaHoy"
        />
  
        <div class="form-check ms-2">
          <input class="form-check-input" type="checkbox" v-model="usarRangoFechas" id="checkRango">
          <label class="form-check-label" for="checkRango">Buscar por rango</label>
        </div>
  
        <input
          v-if="usarRangoFechas"
          type="date"
          v-model="filtroHasta"
          class="form-control"
          :min="filtroDesde"
          :max="fechaHoy"
        />
      </div>
  
      <!-- Filtro por nombre o teléfono -->
      <div class="busqueda-telefono d-flex justify-content-center align-items-center mb-4 px-3">
        <div class="input-group" style="max-width: 400px;">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input
            type="text"
            v-model="busqueda"
            @input="buscarClienteOTelefono"
            class="form-control"
            placeholder="Buscar por nombre o teléfono (todas las rentas)"
          />
        </div>
      </div>
  
      <!-- Cards de rentas -->
      <div class="rentas-grid">
        <div
          class="card-renta"
          v-for="renta in historialFiltrado"
          :key="renta.id_renta"
          @click="toggleExpand(renta.id_renta)"
        >
          <div class="card-header">
            <img :src="formatImage(renta.foto_vestido)" alt="Foto" class="foto-vestido" />
            <div class="card-info">
              <h5 class="cliente">👤 {{ renta.nombre_clienta }}</h5>
              <div class="d-flex align-items-center gap-2">
                <p class="telefono mb-0">📞 {{ renta.telefono }}</p>
                <a
                  v-if="renta.ajustes === 'si' && renta.ajustes_tomados !== 'si' && renta.ajustes_completados !== 'si'"
                  :href="generarMensajeWhatsapp(renta.telefono, renta.nombre_clienta)"
                  target="_blank"
                  class="btn btn-outline-success btn-sm ms-2 d-inline-flex align-items-center"
                >
                  <i class="bi bi-whatsapp me-1"></i> WhatsApp
                </a>
              </div>
              <p class="modelo">👗 {{ renta.modelo_vestido }} - Talla {{ renta.talla }}</p>
              <p class="fecha">🗓️ Renta: {{ formatFecha(renta.fecha_renta) }}</p>
              <div class="etiquetas-flex">
                <span v-if="renta.ajustes === 'si' && renta.ajustes_completados !== 'si'" class="etiqueta badge-ajustes">Ajustes</span>
                <span v-if="renta.ajustes_tomados === 'si' && renta.ajustes_completados !== 'si'" class="etiqueta badge-tomados">Tomados</span>
                <span v-if="renta.ajustes_completados === 'si'" class="etiqueta badge-verde">Ajustes Completados</span>
                <span v-if="renta.entregado === 'si'" class="etiqueta badge-verde">Entregado</span>
                <span v-if="renta.recogio === 'si'" class="etiqueta badge-verde">Recogido</span>
                <span v-if="renta.precio_rentado && (Number(renta.anticipo) + Number(renta.cant_pago_resto || 0)) >= renta.precio_rentado" class="etiqueta badge-pagado">Pagado</span>
                <span v-else class="etiqueta badge-falta">Falta por pagar</span>
              </div>
            </div>
          </div>
  
          <transition name="fade">
            <div v-if="renta.expandido" class="card-detalle">
              <p>📦 Entrega: {{ formatFecha(renta.fecha_entrega) }}</p>
              <p>🔄 Recoge: {{ formatFecha(renta.fecha_recoge) }}</p>
              <p>💲 Precio: ${{ renta.precio_rentado }}</p>
              <p>💵 Anticipo: ${{ renta.anticipo }}</p>
              <p v-if="renta.cant_pago_resto">💰 Pago resto: ${{ renta.cant_pago_resto }}</p>
              <p v-if="renta.ajustes === 'si'">✂️ Ajustes: {{ renta.descripcion_ajustes || 'Sin descripción' }}</p>
              <p v-if="renta.ajustes_tomados === 'si'">📏 Ajustes tomados: {{ renta.descripcion_ajustestomados || 'Sin descripción' }}</p>
              <p v-if="renta.ajustes_completados === 'si'">✅ Ajustes completados</p>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import baseUrl from "../api";
  import moment from "moment-timezone";

  const obtenerFechaHoyLocal = () => {
  const zona = moment.tz.guess();
  return moment().tz(zona).format("YYYY-MM-DD");
};
  
  const mesesCortos = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sept", "oct", "nov", "dic"];
  
  export default {
    name: "HistorialRentas",
    data() {
      const hoy = obtenerFechaHoyLocal();
      return {
        historial: [],
        filtroDesde: hoy,
        filtroHasta: '',
        busqueda: "",
        usarRangoFechas: false,
        fechaHoy: hoy
      };
    },
    computed: {
      historialFiltrado() {
        return this.historial
          .filter(r => {
            const fecha = r.fecha_renta?.split("T")[0];
            if (!fecha) return false;
  
            if (!this.usarRangoFechas) {
              return fecha === this.filtroDesde;
            }
  
            if (this.filtroDesde && fecha < this.filtroDesde) return false;
            if (this.filtroHasta && fecha > this.filtroHasta) return false;
  
            return true;
          })
          .map(r => ({ ...r, expandido: !!r.expandido }));
      }
    },
    methods: {
      async obtenerHistorial() {
        try {
          const res = await axios.get(`${baseUrl}/api/historial-rentas`);
          this.historial = res.data;
        } catch (error) {
          console.error("Error al obtener historial de rentas", error);
        }
      },
      async buscarClienteOTelefono() {
        const query = this.busqueda.trim();
        if (query.length >= 3) {
          try {
            const res = await axios.get(`${baseUrl}/api/buscar-rentas?busqueda=${encodeURIComponent(query)}`);
            this.historial = res.data;
          } catch (error) {
            console.error("Error al buscar por nombre o teléfono", error);
          }
        } else if (query === "") {
          this.obtenerHistorial();
        }
      },
      formatFecha(fecha) {
        if (!fecha) return "Sin fecha";
        const [year, month, day] = fecha.split("T")[0].split("-");
        return `${day} ${mesesCortos[parseInt(month) - 1]} ${year}`;
      },
      formatImage(src) {
        return src ? `${baseUrl}/${src}` : "https://via.placeholder.com/120x160?text=Sin+imagen";
      },
      toggleExpand(id) {
        const renta = this.historial.find(r => r.id_renta === id);
        if (renta) renta.expandido = !renta.expandido;
      },
      generarMensajeWhatsapp(telefono, nombre) {
        const hoy = obtenerFechaHoyLocal();
        const mensaje = `Hola ${nombre}, no olvides acudir para tus ajustes lo antes posible para poder tener en tiempo y forma tu vestido. Te esperamos el día de hoy (${hoy}).`;
        return `https://wa.me/52${telefono}?text=${encodeURIComponent(mensaje)}`;
      }
    },
    watch: {
      usarRangoFechas(nuevoValor) {
        if (nuevoValor && !this.filtroHasta) {
          this.filtroHasta = this.filtroDesde;
        } else if (!nuevoValor) {
          this.filtroHasta = '';
        }
      }
    },
    mounted() {
      this.obtenerHistorial();
    }
  };
  </script>
  
  
  <style scoped>
.rentas-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}
@media (max-width: 768px) {
  .rentas-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
    .filtros-fecha .form-check-input {
    width: 16px;
    height: 16px;
    margin-right: 6px;
    vertical-align: middle;
    accent-color: #aa8a9d;
  }

  .filtros-fecha .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    margin-top: 8px;
  }

  .inventory-summary {
    position: static;
    text-align: center;
    margin-bottom: 10px;
  }

  .inventory-title {
    font-size: 1rem;
    margin-top: -8px;
  }

  .inventory-count {
    font-size: 2rem;
    margin-bottom: 4px;
  }

  .position-absolute.top-0.end-0.mt-3.me-4 {
    position: static !important;
    margin: 0 !important;
  }

  .filtros-fecha {
    flex-direction: row;
    align-items: center;
    gap: 10px !important;
  }

  .filtros-fecha input {
    width: 100%;
    max-width: 300px;
  }
  .container {
    top:-90px;
  }
    
  .rentas-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}



.card-renta {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s;
  position: relative;
  min-height: 220px;
}

.card-renta:hover {
  transform: scale(1.01);
}

.card-header {
  display: flex;
  gap: 15px;
  padding: 15px;
  position: relative;
}

.foto-vestido {
  width: 80px;
  height: 110px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.card-info {
  flex: 1;
  text-align: left;
}

.cliente {
  font-size: 1.1rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 4px;
}

.modelo,
.fecha {
  font-size: 0.9rem;
  color: #555;
  margin: 2px 0;
}

.etiquetas-flex {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.etiqueta {
  font-size: 0.7rem;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: bold;
  white-space: nowrap;
}

.badge-ajustes {
  background-color: #ff8a80;
  color: white;
}

.badge-tomados {
  background-color: #ffd54f;
  color: #333;
}

.badge-verde {
  background-color: #66bb6a;
  color: white;
}

.badge-pagado {
  background-color: #388e3c;
  color: white;
}

.badge-falta {
  background-color: #ffa726;
  color: white;
}

.ajuste-label {
  background-color: #ff8a80;
  top: 10px;
}

.ajuste-tomados {
  background-color: #ffd54f;
  top: 35px;
}

.etiqueta-completado {
  background-color: #66bb6a;
  top: 60px;
}

.etiqueta-entregado {
  background-color: #66bb6a;
  top: 85px;
}

.etiqueta-recogido {
  background-color: #66bb6a;
  top: 110px;
}

.etiqueta-pago {
  position: absolute;
  left: 10px;
  bottom: 10px;
  font-size: 0.75rem;
  font-weight: bold;
  padding: 4px 10px;
  border-radius: 6px;
  color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  z-index: 2;
  white-space: nowrap;
}
.h2{
font-size: 28px;
color: #333;
}
.etiqueta-pagado {
  background-color: #66bb6a;
}

.etiqueta-falta {
  background-color: #ffa726;
}

.btn-whatsapp-ajustes {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 2;
}

.btn-whatsapp-ajustes a {
  color: black;
  font-weight: bold;
  padding: 6px 10px;
  border-radius: 6px;
  text-decoration: none;
  font-size: 0.75rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: background 0.3s;
}

.btn-whatsapp-ajustes a:hover {
  background-color: #1ebe5d;
}

.card-detalle {
  padding: 0 15px 15px;
  border-top: 1px solid #eee;
  font-size: 0.9rem;
  color: #333;
  text-align: left;
}
.telefono {
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 4px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.filtros-fecha input {
  max-width: 200px;
}

.inventory-summary {
  padding: 10px 20px;
  color: #333;
}
.inventory-summary {
  padding: 10px 20px;
  color: #333;
}

.inventory-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444;
  margin: 0;
  letter-spacing: 1px;
}

.inventory-count {
    font-size: 1.8rem;
  font-weight: 600;
  margin: 0;
  color: #aa8a9d;
  font-family: 'Poppins', sans-serif;
}




</style>
